import React, { useEffect, useRef, useState } from "react";
import { Tooltip } from "@toddle-edu/ds-web";
import { useViewportSize } from "Hooks";
import classes from "./TruncateWithTooltip.scss";
import classNames from "classnames";

const TruncateWithTooltip = ({
  children,
  className,
  placement = "top",
  showArrow = true,
  tooltip,
  tooltipMaxWidth = "300px",
  zIndex,
}) => {
  const textRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const viewportSize = useViewportSize();

  useEffect(() => {
    const textElement = textRef.current;

    const checkTruncation = () => {
      if (!textElement || textElement.clientHeight === 0) return;
      const isOverflowing =
        textElement.scrollHeight > textElement.clientHeight ||
        textElement.scrollWidth > textElement.clientWidth;

      setIsTruncated(isOverflowing);
    };

    checkTruncation();
  }, [children, viewportSize]);

  const content = (
    <span ref={textRef} className={classNames(classes.content, className)}>
      {children}
    </span>
  );

  if (!isTruncated) return content;

  return (
    <Tooltip
      tooltip={
        <div style={{ maxWidth: tooltipMaxWidth }}>{tooltip || children}</div>
      }
      showArrow={showArrow}
      placement={placement}
      zIndex={zIndex}
    >
      {content}
    </Tooltip>
  );
};

export default TruncateWithTooltip;
